<template>
    <v-card>
        <v-card-title>{{$props.selectedLocation.site_name}} - {{ $props.selectedNode.node_name }} - Files</v-card-title>

        <v-divider />

        <v-card-text>

            <v-simple-table id="file-list-table" dark v-if="fileMetas.length">
                <template v-slot:default @click="imagePreview">
                <thead>
                    <tr>
                        <th width="45px"></th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Type</th>
                        <th class="text-left">Size</th>
                        <th class="text-left"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(fileMeta, index) in fileMetas" :key="index">
                        <td class="text-center" width="45px">
                            <v-btn icon @click="downloadFile(fileMeta)" v-if="!fileMeta.uploading"><v-icon>mdi-cloud-download</v-icon></v-btn>
                        </td>
                        <td class="text-left">
                            <v-btn icon @click="getImagePreview(fileMeta)" v-if="fileMeta.file_type.includes('image')"><v-icon>mdi-image</v-icon></v-btn>
                            <span :class="{'pad-left': !fileMeta.file_type.includes('image')}">{{ fileMeta.file_name }}</span>
                        </td>
                        <td>{{ fileMeta.file_type }}</td>
                        <td>{{ getReadableFileSize(fileMeta.file_size) }}</td>
                        <td class="text-right">
                            <v-btn icon @click="deleteFileClick(fileMeta)" v-if="!fileMeta.uploading" :disabled="$props.lockSave"><v-icon>mdi-delete</v-icon></v-btn>
                            <v-progress-linear v-if="fileMeta.uploading && fileMeta.uploadProgress != 100" :value="fileMeta.uploadProgress" color="#c42111" />
                            <span v-if="fileMeta.uploading && fileMeta.uploadProgress == 100">processing <v-icon>fas fa-spinner fa-spin</v-icon></span>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>

            <div class="file-error" v-if="error">
                <span v-text="error" />
            </div>

            <vue-dropzone ref="myVueDropzone" id="file-dropzone" :class="{'drag-active': dragActive}" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-file-added="handler" 
                @vdropzone-drag-enter="dragActive = true" @vdropzone-drag-over="dragActive = true" @vdropzone-drag-leave="dragActive = false" :include-styling="false" v-if="!$props.lockSave">
                <div class="dropzone-custom-content">
                    <h3 class="title">Drag and drop to upload content</h3>
                    <div class="subtitle">or click to select a file from your computer</div>
                </div>
            </vue-dropzone>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text color="#ffffff" @click="$emit('close')">ok</v-btn>
        </v-card-actions>

        <v-dialog v-model="showImagePreview" max-width="80%" hide-overlay v-if="showImagePreview">
            <div id="image-preview">
                <img class="img" :src="imagePreview" />
            </div>
        </v-dialog>

    </v-card>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
    name: 'FileBank',
    props: ['selectedLocation', 'selectedNode', 'siteNodeFiles', 'lockSave'],
    components: {
        vueDropzone: vue2Dropzone
    },
    data: () => ({
        fileMetas: [],
        maxFileSizeBytes: 52430000, // actually 50MB
        error: '',
        dropzoneOptions: {
            url: (TELSA.apiHost + "sitebook/files/upload"),
            thumbnailWidth: 150,
            maxFilesize: 9999999999,
            parallelUploads: 6,
            autoQueue: false,
            createImageThumbnails: false,
            previewTemplate: '<div></div>',
        },
        showImagePreview: false,
        imagePreview: null,
        dragActive: false,
    }),

    computed: {
    },

    methods: {
        handler: function(file) {
            this.dragActive = false;
            // Check if file breaks any rules
            if(this.fileMetas.find(fm => {return fm.file_name == file.name;})) {
                // duplicate found
                this.error = `File ${file.name} already exists. You must delete the existing one first or rename it.`;
                return;
            }
            if(file.size > this.maxFileSizeBytes) {
                // File too big
                this.error = `File size exceeds maximum size of ${TELSA.readableFileSize(this.maxFileSizeBytes)}.`;
                return;
            }
            this.error = '';
            this.uploadFile(file);
        },

        uploadFile: function(selectedFile) {
            if(!selectedFile) {
                return;
            }

            let fileObj = {
                site_id: this.$props.selectedLocation.site_id,
                node_id: this.$props.selectedNode.node_id,
                icon: TELSA.getFileIcon(selectedFile.name),
                file_name: selectedFile.name,
                file_type: selectedFile.type,
                file_size: selectedFile.size,
                uploading: true,
                uploadProgress: 0,
            };
            let fileObjTransport = JSON.parse(JSON.stringify(fileObj));

            let self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.fileMetas.push(fileObj);
                self.$props.siteNodeFiles.push(fileObj);
                fileObjTransport.file_data = e.target.result;

                let route = (TELSA.apiHost + "sitebook/files/upload");
                return self.$http.post(route, {args: {file: fileObjTransport}},
                    {progress(e) {
                        let progress = Math.floor((e.loaded / e.total) * 100);
                        fileObj.uploadProgress = progress;
                    }}
                    ).then(response => {
                        let result = response.body;
                        fileObj.uploading = false;
                    }
                );
            }
            reader.readAsDataURL(selectedFile);
        },

        getReadableFileSize: function(size) {
            return TELSA.readableFileSize(size);
        },

        deleteFileClick: function(fileMeta) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete File',
                message: `This operation will permanently delete <b>${fileMeta.file_name}</b>. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteFile(fileMeta)
            });
        },
        deleteFile: function(fileMeta) {
            let route = (TELSA.apiHost + "sitebook/files/delete");
            TELSA.loading(true);
            this.fileMetas.splice(this.fileMetas.indexOf(fileMeta), 1);

            for(let siteNodeFile of this.$props.siteNodeFiles) {
                if(fileMeta.node_id == siteNodeFile.node_id && fileMeta.file_name == siteNodeFile.file_name) {
                    this.$props.siteNodeFiles.splice(this.$props.siteNodeFiles.indexOf(siteNodeFile), 1);
                }
            }

            return this.$http.post(route, {args: {file: fileMeta}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        downloadFile: function(fileMeta) {
            let dlink = document.createElement('a');
            dlink.setAttribute("id", "file-download-link-hidden");
            let url = new URL(`${TELSA.apiHost}sitebook/files/download`);
            url.searchParams.append('username', this.$store.state.user.user_username);
            url.searchParams.append('user_access', this.$store.state.user.user_access);
            url.searchParams.append('site_id', fileMeta.site_id);
            url.searchParams.append('node_id', fileMeta.node_id);
            url.searchParams.append('file_name', fileMeta.file_name);
            dlink.href = url;
            TELSA.downloadFileFlag = true;
            dlink.click();
            dlink.remove();
            TELSA.downloadFileFlag = false;
        },

        getImagePreview: function(fileMeta) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "sitebook/files/data");
            return this.$http.post(route, {args: {site_id: fileMeta.site_id, node_id: fileMeta.node_id, file_name: fileMeta.file_name}}).then(response => {
                let result = response.body;
                this.imagePreview = result.file_data;
                this.showImagePreview = true;
                TELSA.loading(false);
            });
        }

    },

    mounted() {
        let id = this.$props.selectedNode.node_id;
        for(let siteNodeFile of this.$props.siteNodeFiles) {
            if(id == siteNodeFile.node_id) {
                if(!siteNodeFile.icon) {
                    siteNodeFile.icon = TELSA.getFileIcon(siteNodeFile.file_name);
                }
                this.fileMetas.push(siteNodeFile);
            }
        }
    }

  
};
</script>

<style scoped>

    #file-list-table {
        overflow: auto;
        max-height: calc(100vh - 450px);
    }

    #file-dropzone {
        margin-top: 2em;
        border: #000000 solid 1px;
        text-align: center;
        padding: 2em;
        cursor: pointer;
        background-color: rgba(48,48,48,0.75);
    }

    #file-dropzone.drag-active {
        border: #4caf50 solid 1px;
        background-color: rgba(48,48,48,0.5);
    }

    .pad-left {
        margin-left: 36px;
    }

    .file-error {
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        color: #ff5252;
        margin-top: 0.5em;
        margin-left: 1em;
    }

    #file-dropzone .title {
        color: #ffffff;
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    #file-dropzone .subtitle {
        color: #ffffff;
    }

    #image-preview {
        position: relative;
        text-align: center;
        margin: auto;
        background-color: #424242;
    }
    #image-preview .img {
        max-width:100%;
        max-height:100%;
    }

    @keyframes shake-horizontal {
        0%,
        100% {
            transform: translateX(0);
        }
        10%,
        30%,
        50%,
        70% {
            transform: translateX(-10px);
        }
        20%,
        40%,
        60% {
            transform: translateX(10px);
        }
        80% {
            transform: translateX(8px);
        }
        90% {
            transform: translateX(-8px);
        }
    }

</style>
